module.exports = __webpack_public_path__ + "img/600_SERF_2022_Nice-Try.e629918a.png";